import { render, staticRenderFns } from "./news.vue?vue&type=template&id=66feabe9&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=66feabe9&prod&scoped=true&lang=css&"
import style1 from "./news.vue?vue&type=style&index=1&id=66feabe9&prod&lang=scss&scoped=true&"
import style2 from "./news.vue?vue&type=style&index=2&id=66feabe9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66feabe9",
  null
  
)

export default component.exports